module.exports = __webpack_public_path__ + "img/teeth-46.1fcc93c5.png";